var _rect, _rect2, _polygon, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1024,
    height: 1024,
    rx: 192,
    fill: "#18181b"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 136,
    width: 672,
    height: 536,
    rx: 80,
    fill: "#fafafa",
    opacity: 0.92
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "360,672 460,672 388,776",
    fill: "#fafafa",
    opacity: 0.92
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 512,
    cy: 340,
    r: 96,
    fill: "#27272a"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M392 560C392 488 444 428 512 428C580 428 632 488 632 560",
    fill: "#27272a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.5da518ee44e65aae32726a2beb6641e4.svg";
export { ForwardRef as ReactComponent };